var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntensePain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#004887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 13C24.5523 13 25 13.4477 25 14V18C25 18.5523 24.5523 19 24 19C23.4477 19 23 18.5523 23 18V14C23 13.4477 23.4477 13 24 13Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 29C24.5523 29 25 29.4477 25 30V34C25 34.5523 24.5523 35 24 35C23.4477 35 23 34.5523 23 34V30C23 29.4477 23.4477 29 24 29Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2231 16.2229C16.6136 15.8324 17.2468 15.8324 17.6373 16.2229L20.4673 19.0529C20.8578 19.4434 20.8578 20.0766 20.4673 20.4671C20.0768 20.8576 19.4436 20.8576 19.0531 20.4671L16.2231 17.6371C15.8325 17.2466 15.8325 16.6134 16.2231 16.2229Z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5331 27.5329C27.9237 27.1424 28.5568 27.1424 28.9473 27.5329L31.7773 30.3629C32.1679 30.7534 32.1679 31.3866 31.7773 31.7771C31.3868 32.1676 30.7537 32.1676 30.3631 31.7771L27.5331 28.9471C27.1426 28.5566 27.1426 27.9234 27.5331 27.5329Z",
    fill: "#FCFCFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 24C13 23.4477 13.4477 23 14 23H18C18.5523 23 19 23.4477 19 24C19 24.5523 18.5523 25 18 25H14C13.4477 25 13 24.5523 13 24Z",
    fill: "#FCFCFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 24C29 23.4477 29.4477 23 30 23H34C34.5523 23 35 23.4477 35 24C35 24.5523 34.5523 25 34 25H30C29.4477 25 29 24.5523 29 24Z",
    fill: "#FCFCFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4673 27.5329C20.8578 27.9234 20.8578 28.5566 20.4673 28.9471L17.6373 31.7771C17.2468 32.1676 16.6136 32.1676 16.2231 31.7771C15.8325 31.3866 15.8325 30.7534 16.2231 30.3629L19.0531 27.5329C19.4436 27.1424 20.0768 27.1424 20.4673 27.5329Z",
    fill: "#FCFCFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7773 16.2229C32.1679 16.6134 32.1679 17.2466 31.7773 17.6371L28.9473 20.4671C28.5568 20.8576 27.9237 20.8576 27.5331 20.4671C27.1426 20.0766 27.1426 19.4434 27.5331 19.0529L30.3631 16.2229C30.7537 15.8324 31.3868 15.8324 31.7773 16.2229Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntensePain);
export default __webpack_public_path__ + "static/media/intense-pain.534eb71b489bc53b3d280a0caa9242ad.svg";
export { ForwardRef as ReactComponent };